import { useRef } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom"


// Questo è un middleware che contralla se l'utente ha il booleano isUserShopOrderAvailable è true, quindi è abilitato ad effettuare acquisti
const UserShippingDataCheck = () => {
    const location = useLocation();

    const { isUserShopOrderAvailable } = useSelector(state => state.user);
    const hasNavigated = useRef(false);
    // Se l'utente è abilitato all'acquisto in shop (dati di spedizione inseriti (isAvailable)) navigo verso confirm-ored-request
    // Altrimenti verso la pagina di inserimento dati di acquisto
    if (!hasNavigated.current) {
        if (!isUserShopOrderAvailable) {
            hasNavigated.current = true;
            return <Navigate to="/set-shipping-data" state={location.state} />
        }
    }
    return <Outlet context={location.state} />
}

export default UserShippingDataCheck